import request from "@/utils/request";


// 获取远程数据 url参数的形式传入
export function getRemoteData(url, method, param) {
    return request({
        url: url,
        method: method,
        headers: {
            isToken: true,
        },
        params: param
    })
}

// 评论
export function commentAPI(data) {
    return request({
        url: '/flow/comment',
        method: 'post',
        headers: {
            isToken: true,
        },
        data
    })
}

// 重新发起时取formData的方法
export function getFormDataByInstanceId(processInstanceId) {
    return request({
        url: '/flow/task/getFormDataByInstanceId?processInstanceId=' + processInstanceId,
        headers: {
            isToken: true,
        },
        method: 'get'
    })
}

// 流程列表
export function workList(data) {
    return request({
        url: '/flow/task/workList',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

// 获取工作台数据
export function getUseFlows(params) {
    return request({
        url: '/flow/templates/getUseFlows',
        headers: {
            isToken: true,
        },
        method: 'get',
        params,
    })
}

// 查询表单信息
export function getFormInfoAPI(params) {
    return request({
        url: '/flow/task/getFormInfo',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}


// 查科目 - 2024年4月17日 弃用
export function getSubject(params) {
    return request({
        url: '/fm/fmSubject/getSubject?level=3&subjectType=FY&status=0&delFlag=0',
        headers: {
            isToken: true,
        },
        method: 'get',
        params
    })
}

/**
 *  流程开始，提交
 * @param data
 * @returns {*}
 */
export function flowStartAPI(data) {
    return request({
        url: '/flow/task/start',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

/**
 *  查询流程详情
 * @param data
 * @returns {*}
 */
export function getReservationInfoAPI(data) {
    return request({
        url: '/flow/task/getProcessInfo',
        method: 'post',
        headers: {
            isToken: true,
        },
        data: data
    })
}

/**
 * 保存表单
 * @param data
 * @returns {*}
 */
export function saveForm(data) {
    return request({
        url: '/flow/task/saveForm',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

/**
 *  拒绝
 */
export function refuseAPI(data) {
    return request({
        url: '/flow/task/refuse',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

/**
 * 回退
 */
export function onBackAPI(data) {
    return request({
        url: '/flow/task/back',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

/**
 *  同意
 * @param param
 * @returns {*}
 */
export function agreeAPI(data) {
    return request({
        url: '/flow/task/agree',
        method: 'post',
        headers: {
            isToken: true,
        },
        data
    })
}

// 撤回
export function rejectFlowAPI(data) {
    return request({
        url: '/flow/task/reject',
        headers: {
            isToken: true,
        },
        method: 'POST',
        data
    });
}

// 加签
export function counterSign(data) {
    return request({
        url: '/flow/task/counterSign',
        headers: {
            isToken: true,
        },
        method: 'POST',
        data: data,
    });
}

// 撤销流程
export function taskRevoke(data) {
    return request({
        url: '/flow/task/revoke',
        method: 'POST',
        headers: {
            isToken: true,
        },
        data
    })
}

// 获取科目树
export function getSubjectTree(params) {
    return request({
        url: '/fm/fmSubject/getSubjectTree',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

/**
 *  流程转办
 * @param data
 * @returns {*}
 */
export function chgAssignee(data) {
    return request({
        url: '/flow/task/chgAssignee',
        method: 'post',
        headers: {
            isToken: true,
        },
        data
    })
}

// 获取用餐统计
export function getFoodOrderStat(params) {
    return request({
        url: '/system/foodOrder/stat',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}


/**
 *  我发起的申请数据
 * @param data
 * @returns {*}
 */
export function flowApplyAPI(data) {
    return request({
        url: '/flow/task/applyList',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

// 关联流程获取表单详情
export function getRelaveFormDataByInstanceId(params) {
    return request({
        url: '/flow/instance/getRelaveFormDataByInstanceId',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

/**
 *  我的待办列表
 * @param data
 * @returns {*}
 */
export function backlogList(data) {
    return request({
        url: '/flow/task/toDoList',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

/**
 * 我的已办列表
 * @param data
 * @returns {*}
 */
export function havedoneList(data) {
    return request({
        url: '/flow/task/doneList',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

/**
 *  我发起的列表
 * @param param
 * @returns {*}
 */
export function sponsorList(data) {
    return request({
        url: '/flow/task/applyList',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

/**
 * 抄送我的列表
 * @param param
 * @returns {*}
 */
export function receiveList(data) {
    return request({
        url: '/flow/task/receiveList',
        headers: {
            isToken: true,
        },
        method: 'post',
        data
    })
}

// 报销查询历史收款人
export function flowAccountList(params) {
    return request({
        url: '/work/FlowAccount/list',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 报销查询历史收款人
export function removeFlowAccount(id) {
    return request({
        url: '/work/FlowAccount/' + id,
        method: 'delete',
        headers: {
            isToken: true,
        }
    })
}

// 子公司列表
export function fmInvoiceList(params) {
    return request({
        url: '/fm/fmInvoice/list',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 合同列表
export function contractList(params) {
    return request({
        url: '/system/contract/list',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 分页查询用户下的合同列表
export function contractListByUserId(params) {
    return request({
        url: '/contract/members/listPageContractByUserId',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 查询用户相关的项目列表
export function projectListByUserId(params) {
    return request({
        url: '/project/project/selectMyProjectList',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 获取已开票金额
export function getInvoiceAmount(params) {
    return request({
        url: '/work/invoice/getInvoiceAmount',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 查关联项目和关联合同
export function listContractAndProject(params) {
    return request({
        url: '/contract/members/listContractAndProject',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 备用金列表
export function queryImprest(params) {
    return request({
        url: '/work/expense/queryImprest',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}
// 获取成本归属部门
export function selectProjectDept(params) {
    return request({
        url: '/system/contract/selectProjectDept',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}


